module.exports = window["VueRouter"];